<template>
  <div class="lg:w-1/2 w-auto">
      <div class="text-center">
        <div class="flex-wrap pt-3 ">
          <h3 class="text-2xl text-gray-900 border-b">Bestellübersicht</h3>
          <div class="bg-gray-200 h-auto lg:px-32 px-6 mt-3 py-2">
            <h1 class="text-xl py-1 text-left">
              Gesamtbetrag
              <span class="float-right text-teal-400">{{ total | formatNumber }}</span>
            </h1>

            <div  v-if="CouponUsed == true" >
            <div class="w-full">
                <p class="text-md py-1 text-left">
                  Rabatt
                  <span class="float-right">- {{ (total - Propcoupon) | formatNumber }}</span>
                </p>
              </div>
            </div>

            <hr v-if="CouponUsed == true">

            <div v-if="CouponUsed == true" >
              <h1  class="text-xl py-1 text-left ">
                Preis mit Gutschein
                <span class="float-right text-red-400">{{ Propcoupon | formatNumber }}</span>
                
              </h1>
          </div>


            <div v-if="CouponUsed == false" >
              <div class="w-full">
                <p class="text-md py-1 text-left">
                  inkl. MwSt.
                  <span class="float-right">{{ total * 0.19 | formatNumber }}</span>
                </p>
              </div>
            </div>

            <div v-if="CouponUsed == true" >
              <div class="w-full">
                <p class="text-md py-1 text-left">
                  inkl. MwSt.
                  <span class="float-right">{{ Propcoupon * 0.19 | formatNumber }}</span>
                </p>
              </div>
            </div>


          

            <div class="py-2">
              <p class="text-left text-sm">Mit Ihrer Bestellung erklären Sie sich mit unseren 
                <router-link tag="a" to="/daten" class="hover:underline text-teal-400">
                  Datenschutzbestimmungen
                </router-link> 
                und 
                <router-link tag="a" to="/agb" class="hover:underline text-teal-400">
                  AGB 
                </router-link>
                einverstanden.
              </p>
            </div>
            <!-- <div class="py-2">
              <p class="text-left text-sm">
                <span class="font-semibold">
                  Gutscheincodes 
                </span> 
                können im letzten Bestellschritt "Bestätigen" eingelöst werden.</p>
            </div> -->
            <div class="">
              <hr>
            </div>
            <div>
              <p class="text-left font-semibold border-b py-1">Warenkorb</p>
              <div class="max-w-md w-full lg:flex py-1" v-for="item in cartItems" :key="item.id">
                <div class="lg:h-auto lg:w-20 flex-none bg-cover  text-center overflow-hidden">
                  <img class="lg:w-20" :src="item.img" alt="Item Img">
                </div>
                <div class="flex flex-col justify-between leading-normal">
                  <div class="mb-8 pl-2">
                    <div class="text-left text-sm font-semibold">{{ item.product_name }}</div>
                    <p class="text-left text-xs">
                      Anzahl:
                      <span class="font-semibold">
                        {{ item.qty }}
                      </span>
                    </p>
                    <p class="font-semibold text-left">{{item.sale_price | formatNumber}}</p>
                  </div>
                  <div class="flex items-center">
                    <div class="text-sm">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <hr>
            <div v-if="Object.keys(this.finalModel).length > 0">
              <p class="text-left text-sm font-semibold">Lieferaddresse</p>
              <div>
                <p class="text-left">
                  <span class="text-sm">
                    Name: {{finalModel.name }}
                  </span>
                  <br>
                  <span class="text-sm">
                    {{ finalModel.address_1 }}
                  </span>
                  <br>
                  <span class="text-sm">
                    {{ finalModel.address_2 }}
                  </span>
                  <br>
                  <span class="text-sm">
                    {{ finalModel.zip }} {{ finalModel.city}}
                  </span>
                  <br>
                  <span class="text-sm">
                    {{finalModel.country }}
                  </span>
                  <br>
                  <span class="text-sm">
                    Tel: {{ finalModel.phone }}
                  </span>
                  <br>
                  <span class="text-sm">
                    E-Mail: {{ finalModel.email }}
                  </span>
                  <br>
                  <span class="text-sm">
                    {{ finalModel.shipping }}
                  </span>
                </p>
              </div>
              <!-- <p>{{finalModel}}</p> -->
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  props: {
    cartItems: Array,
    finalModel: Object,
    Propcoupon: Number,
    CouponUsed: Boolean
  },
  data() {
    return {
      address: {}
    };
  },
  // watch: {
  //   finalModel: function() {
  //     console.log(this.finalModel);
  //     this.address = this.finalModel;
  //   }
  // },
  computed: {
    getCartItems() {
      return this.cartItems;
    },
    checkModel() {
      return this.finalModel
    },
    total() {
      let sum = 0;
      this.cartItems.map(item => {
        sum += item.sale_price;
      });
      return sum;
    },
    getAddress() {
      return `${this.type} ${this.address_1}`;
    }
  },
  
};
</script>

<style>
</style>